import React, { Component } from "react";
import "../styles/owl.carousel.min.css";
import "../styles/owl.theme.default.min.css";
import "../styles/flexslider.css";
import { Link } from "react-router-dom";

import { BeatLoader } from "react-spinners";
import CountUp from "react-countup";
import "../components/corona/coronaStats.css";
//const baseUrl = "http://localhost:3000/";
const baseUrl = process.env.PUBLIC_URL;

class HeaderComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddClass: false,
      statList: {
        confirmed: "",
        deaths: "",
        recovered: ""
      }
    };
  }

  async componentDidMount() {
    window["sliderMain"]();
    window["fullHeight"]();
    await fetch("https://covid19.mathdro.id/api")
      .then(response => response.json())
      .then(data =>
        this.setState({
          statList: {
            confirmed: data.confirmed.value,
            deaths: data.deaths.value,
            recovered: data.recovered.value
          }
        })
      )
      .catch(e => <p>{e.message}</p>);
  }

  render() {
    let btnClass = ["animated", "fadeInUp"];

    btnClass = btnClass.join(" ");
    return (
      <React.Fragment>
        <section
          id="colorlib-hero"
          className="js-fullheight"
          data-section="home"
        >
          <div className="flexslider js-fullheight">
            <ul className="slides">
              <li
                style={{
                  backgroundImage: `url(${baseUrl}/assets/images/corona.jpg)`
                }}
              >
                <div className="overlay"></div>
                <div className="container-fluid">
                  <div className="row">
                    <div
                      className={`col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text ${
                        this.state.isAddClass ? btnClass : ""
                      }`}
                    >
                      <div className="slider-text-inner js-fullheight">
                        <div className="desc">
                          <div
                            id="corona-stats"
                            style={{
                              backgroundColor: "black",
                              padding: "15px"
                            }}
                          >
                            {/* <Stats url="https://covid19.mathdro.id/api" /> */}
                            <h1
                              style={{
                                fontSize: "26px",
                                fontWeight: "bold"
                              }}
                            >
                              Infected Cases :<br />
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "56px"
                                }}
                              >
                                {!this.state.statList.confirmed ? (
                                  <BeatLoader loading color="red" />
                                ) : (
                                  <CountUp
                                    end={this.state.statList.confirmed}
                                    duration={2}
                                    suffix={"+"}
                                  />
                                )}
                              </span>
                            </h1>
                            <h1
                              style={{
                                fontSize: "26px",
                                fontWeight: "bold"
                              }}
                            >
                              Death Cases :<br />
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "56px"
                                }}
                              >
                                {!this.state.statList.deaths ? (
                                  <BeatLoader loading color="red" />
                                ) : (
                                  <CountUp
                                    end={this.state.statList.deaths}
                                    duration={2}
                                    suffix={"+"}
                                  />
                                )}
                              </span>
                            </h1>
                            <h1
                              style={{
                                fontSize: "26px",
                                fontWeight: "bold"
                              }}
                            >
                              Recovered Cases :<br />
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "56px"
                                }}
                              >
                                {" "}
                                {!this.state.statList.recovered ? (
                                  <BeatLoader loading color="red" />
                                ) : (
                                  <CountUp
                                    end={this.state.statList.recovered}
                                    duration={2}
                                    suffix={"+"}
                                  />
                                )}
                              </span>
                            </h1>
                          </div>
                          <h2>
                            I build interactive websites that run across
                            platforms & devices &nbsp;
                            <br />
                          </h2>
                          <p>
                            <Link
                              style={{
                                border: "red 1px solid",
                                fontSize: "20px",
                                fontWeight: "bold"
                              }}
                              className="btn btn-primary btn-learn"
                              to="/updates"
                            >
                              Live Updates
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                style={{
                  backgroundImage: `url(${baseUrl}/assets/images/bg_1.jpg)`
                }}
              >
                <div className="overlay"></div>
                <div className="container-fluid">
                  <div className="row">
                    <div
                      className={`col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text ${
                        this.state.isAddClass ? btnClass : ""
                      }`}
                    >
                      <div className="slider-text-inner js-fullheight">
                        <div className="desc">
                          <h1>I'm Achyuth</h1>
                          <h2>
                            I build interactive websites that run across
                            platforms & devices &nbsp;
                            <br />
                            <Link to="/contact" style={{ color: "white" }}>
                              Let's make something special
                            </Link>
                          </h2>
                          <p>
                            <button
                              onClick={() => {
                                window.location.href = `${baseUrl}/assets/docs/Achyuth_Developer_React.docx`;
                              }}
                              className="btn btn-primary btn-learn"
                            >
                              Download CV <i className="icon-download4"></i>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                style={{
                  backgroundImage: `URL(${baseUrl}/assets/images/bg_2.jpg)`
                }}
              >
                <div className="overlay"></div>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                      <div className="slider-text-inner">
                        <div className="desc">
                          <h1>I'm </h1>
                          <h2>
                            the Front-End Developer , I have serious passion for
                            UI effects, animations and creating intuitive,
                            dynamic user experiences.
                          </h2>
                          <p>
                            <Link
                              className="btn btn-primary btn-learn"
                              to="/work"
                            >
                              View Portfolio
                              <i className="icon-briefcase3"></i>
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default HeaderComponent;
